import api from '../../../services/api'

export default {
   

    createControl(registro) {
        return  api().post('control/create/',registro );
    },
    searchRangeControl(dni,tipo,inicial,final) {
        return  api().post('control/search_range/'+dni+'/'+tipo+'/'+inicial+'/'+final );
    }
}